import { SvgIcon } from '@streamelements/frontend-icons';
import { Box, Button, Text, Tooltip } from '@streamelements/frontend-ui';
import { Dispatch, SetStateAction } from 'react';

export function ToggleHideStreamKeyButton({
  isVisible,
  setVisible,
}: {
  isVisible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <Tooltip.Root delayDuration={0}>
      <Tooltip.Trigger asChild>
        <Button iconButton variant="ghost" color="neutral" onClick={() => setVisible((prev) => !prev)}>
          <Box as={SvgIcon} css={{ '&&': { fill: 'none', stroke: 'CurrentColor' } }}>
            {isVisible ? (
              <>
                <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                <line x1="2" x2="22" y1="2" y2="22" />
              </>
            ) : (
              <>
                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                <circle cx="12" cy="12" r="3" />
              </>
            )}
          </Box>
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Text.Body variant="caption">{isVisible ? 'Hide Stream Key' : 'Show Stream Key'}</Text.Body>
      </Tooltip.Content>
    </Tooltip.Root>
  );
}
